import { render, staticRenderFns } from "./ObjectMetaViewer.vue?vue&type=template&id=8d4efd16&scoped=true&"
import script from "./ObjectMetaViewer.vue?vue&type=script&lang=js&"
export * from "./ObjectMetaViewer.vue?vue&type=script&lang=js&"
import style0 from "./ObjectMetaViewer.vue?vue&type=style&index=0&id=8d4efd16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4efd16",
  null
  
)

export default component.exports